module.exports = __webpack_public_path__ + "img/664468.32267a64.png";